import {AbstractProfileCollection} from './abstractProfileCollection';
import {Assessment} from '../model/assessment';

export const Assessments = AbstractProfileCollection.extend({
    _name: 'Assessments',
    model: Assessment,
    urlRoot: '/assessments/get.json',
});
